import { PrimaryOutlineButton } from '@/components/button/button-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { useFormContext } from 'react-hook-form';
import { MdOutlineCheckCircle } from 'react-icons/md';
import styled from 'styled-components';
import updateEmailTemplateApi from '../../api/post/account/update-email-template';
import Alert from '../../components/alert/alert-component';
import { useMutation } from '../../hooks/use-api';

const TextInput = styled(Input)`
  min-height: 40vh;
`;

/**
 * CoverLetter form for the Quote Summary page - CoverLetter Tab.
 * @file CoverLetterForm.jsx
 * @returns {JSX.Element} The rendered CoverLetter Form component.
 */
const QuoteCoverLetterForm = () => {
  const {
    formState: { isLoading: formLoading },
    watch,
  } = useFormContext();

  const [updateEmailTemplate, { loading: updateEmailTemplateLoading }] =
    useMutation(updateEmailTemplateApi);

  const templateValue = watch('quote.cover_letter');

  return (
    <>
      <TextInput
        label="Cover Letter Text"
        name="quote.cover_letter"
        textArea
        maxlength="20000"
      />
      <PrimaryOutlineButton
        type="button"
        loading={formLoading || updateEmailTemplateLoading}
        buttonWidth="190px"
        title="Save as template"
        icon={<MdOutlineCheckCircle />}
        onClick={() =>
          updateEmailTemplate({ email_template: templateValue })
            .then(() => {
              Alert({
                icon: 'success',
                text: 'Cover Letter saved successfully',
              });
            })
            .catch(() => {
              Alert({
                icon: 'error',
                text: 'Failed to save Cover Letter',
              });
            })
        }
      />
    </>
  );
};

export default QuoteCoverLetterForm;
